/**
 * Type-safe check for a null or undefined type.
 * @param {any} x -- the variable to check
 */
export default function isNil<T>(x: T | undefined | null): x is null | undefined {
  return x === undefined || x === null;
}
